/**
 * Mobile Menu Toggle
 * 
 * Handles mobile menu open/close functionality with accessibility support
 */

const MOBILE_NAV_MQ = '(width < 64rem)';

class MobileMenu {
  constructor() {
    this.toggle = document.querySelector('.mobile-menu-toggle');
    this.nav = document.querySelector('.primary-navigation');
    this.overlay = document.querySelector('.mobile-menu-overlay');
    this.body = document.body;
    this.isOpen = false;

    if (!this.toggle || !this.nav) {
      return;
    }

    this.init();
  }

  init() {
    // Toggle button click
    this.toggle.addEventListener('click', () => this.toggleMenu());

    // Overlay click to close
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeMenu());
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeMenu();
      }
    });

    // Handle submenu toggles on mobile
    this.initSubmenuToggles();

    // Close menu on window resize to desktop
    window.addEventListener('resize', () => {
      if (!window.matchMedia(MOBILE_NAV_MQ).matches && this.isOpen) {
        this.closeMenu();
      }
    });
  }

  toggleMenu() {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.isOpen = true;
    this.nav.classList.add('is-active');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.body.classList.add('mobile-menu-open');

    if (this.overlay) {
      this.overlay.classList.add('is-active');
    }

    // Focus first menu item
    const firstMenuItem = this.nav.querySelector('.nav-menu a');
    if (firstMenuItem) {
      setTimeout(() => firstMenuItem.focus(), 300);
    }
  }

  closeMenu() {
    this.isOpen = false;
    this.nav.classList.remove('is-active');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.body.classList.remove('mobile-menu-open');

    if (this.overlay) {
      this.overlay.classList.remove('is-active');
    }

    // Return focus to toggle button
    this.toggle.focus();
  }

  initSubmenuToggles() {
    const menuItemsWithChildren = this.nav.querySelectorAll('.menu-item-has-children');

    menuItemsWithChildren.forEach((item) => {
      const link = item.querySelector(':scope > a');
      const submenu = item.querySelector(':scope > .sub-menu');
      const megaPanel = item.querySelector(':scope > .mega-menu');
      const isMega = item.classList.contains('is-mega-menu');

      if (!link || (!submenu && !megaPanel)) return;

      link.addEventListener('click', (e) => {
        if (window.matchMedia(MOBILE_NAV_MQ).matches) {
          e.preventDefault();

          if (isMega && megaPanel && window.PvtlMegaMenu) {
            window.PvtlMegaMenu.constructor.toggleMobile(item);
            return;
          }

          if (submenu) {
            this.toggleSubmenu(item, submenu);
          }
        }
      });
    });
  }

  toggleSubmenu(item, submenu) {
    const isOpen = item.classList.contains('is-open');

    const allItems = this.nav.querySelectorAll('.menu-item-has-children');
    allItems.forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.classList.remove('is-open');
        const otherSubmenu = otherItem.querySelector(':scope > .sub-menu');
        if (otherSubmenu) {
          otherSubmenu.classList.remove('is-open');
        }
        if (otherItem.classList.contains('is-mega-menu') && window.PvtlMegaMenu) {
          const otherTrigger = otherItem.querySelector(':scope > a');
          const otherPanel = otherItem.querySelector(':scope > .mega-menu');
          if (otherTrigger && otherPanel) {
            otherItem.classList.remove('is-mega-open');
            otherTrigger.setAttribute('aria-expanded', 'false');
            otherPanel.classList.remove('is-open');
            otherPanel.setAttribute('hidden', '');
          }
        }
      }
    });

    // Toggle current submenu
    if (isOpen) {
      item.classList.remove('is-open');
      submenu.classList.remove('is-open');
    } else {
      item.classList.add('is-open');
      submenu.classList.add('is-open');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MobileMenu());
} else {
  new MobileMenu();
}
